import { Card, CardContent } from "@mui/material";
import { Title } from "react-admin";
import { JsonStyled } from "../components/jsonStyled";
import { ENV } from "../utils/tools";

export const EnvSettings = () => {
  return (
    <Card className="EnvSettings" sx={{ overflow: "auto" }}>
      <Title title="Settings" />
      <CardContent>
        <JsonStyled data={ENV()} wrapperStyle={{ maxHeight: "auto" }} />
      </CardContent>
    </Card>
  );
};
